import { useEffect, useState } from "react";
import { useToast, Box, Text, Grid, GridItem, Heading, Button, Input, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure } from "@chakra-ui/react";

const Algorithms = () => {
    const [algorithms, setAlgorithms] = useState([]);
    const [selectedAlgorithm, setSelectedAlgorithm] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure();
    const [newAlgorithm, setNewAlgorithm] = useState({ name: '', description: '' });
    const toast = useToast();

    useEffect(() => {
        fetchAlgorithms();
    }, []);

    const fetchAlgorithms = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/algorithms', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Erro ao buscar algoritmos');
            const data = await response.json();
            setAlgorithms(data);
        } catch (error) {
            toast({
                title: "Erro ao buscar algoritmos",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const handleOpenEditModal = (algorithm) => {
        setSelectedAlgorithm(algorithm);
        onEditOpen();
    };

    const handleNewAlgorithmInputChange = (e) => {
        const { name, value } = e.target;
        setNewAlgorithm(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectedAlgorithmInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedAlgorithm(prev => ({ ...prev, [name]: value }));
    };

    const handleAddAlgorithm = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/algorithms', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(newAlgorithm),
            });

            if (!response.ok) {
                throw new Error('Erro ao adicionar algoritmo');
            }

            const addedAlgorithm = await response.json();
            setAlgorithms(prev => [...prev, addedAlgorithm]);
            setNewAlgorithm({ name: '', description: '' });
            onClose();
            
            toast({
                title: "Algoritmo adicionado com sucesso",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: "Erro ao adicionar algoritmo",
                description: error.message,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const handleUpdateAlgorithm = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`/api/algorithms/${selectedAlgorithm.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(selectedAlgorithm),
            });

            if (!response.ok) {
                throw new Error('Erro ao atualizar algoritmo');
            }

            const updatedAlgorithm = await response.json();
            setAlgorithms(prev => 
                prev.map(algorithm => 
                    algorithm.id === updatedAlgorithm.id ? updatedAlgorithm : algorithm
                )
            );
            onEditClose();
            
            toast({
                title: "Algoritmo atualizado com sucesso",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        } catch (error) {
            toast({
                title: "Erro ao atualizar algoritmo",
                description: error.message,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    return (
        <Box p={6} flex="1" minH="100vh" bg="gray.100" justify="center">
            <Heading mb={4}>
                Algoritmos
                <Button onClick={onOpen} ml={4} colorScheme="teal">Adicionar Algoritmo</Button>
            </Heading>
            <Text fontSize="xl" mb={4}>Lista de algoritmos disponíveis:</Text>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                {algorithms.map((algorithm) => (
                    <GridItem key={algorithm.id} w="100%" bg="white" boxShadow="md" p={4} borderRadius="md">
                        <Text fontSize="lg" fontWeight="bold" onClick={() => handleOpenEditModal(algorithm)} cursor="pointer">
                            {algorithm.name}
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                            {algorithm.description}
                        </Text>
                    </GridItem>
                ))}
            </Grid>

            {/* Modal para Adicionar Novo Algoritmo */}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Adicionar Novo Algoritmo</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Input 
                            placeholder="Nome do Algoritmo" 
                            name="name" 
                            value={newAlgorithm.name} 
                            onChange={handleNewAlgorithmInputChange} 
                            mb={4}
                        />
                        <Input 
                            placeholder="Descrição" 
                            name="description" 
                            value={newAlgorithm.description} 
                            onChange={handleNewAlgorithmInputChange} 
                            mb={4}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="teal" onClick={handleAddAlgorithm}>Adicionar</Button>
                        <Button onClick={onClose} ml={3}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Modal para Editar Algoritmo */}
            <Modal isOpen={isEditOpen} onClose={onEditClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Editar Algoritmo</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Input
                            placeholder="Nome do Algoritmo"
                            name="name"
                            value={selectedAlgorithm?.name || ''}
                            onChange={handleSelectedAlgorithmInputChange}
                            mb={4}
                        />
                        <Input
                            placeholder="Descrição"
                            name="description"
                            value={selectedAlgorithm?.description || ''}
                            onChange={handleSelectedAlgorithmInputChange}
                            mb={4}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="teal" onClick={handleUpdateAlgorithm}>Salvar Alterações</Button>
                        <Button onClick={onEditClose} ml={3}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default Algorithms;
